import React from "react";
import { GridProvider } from "./../../context/GridContext"; // Adjust the import path as necessary
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
import TableFooter from "./TableFooter";
import classes from "./commonGrid.module.css";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { useCommonGrid } from "../../hooks/useCommonGrid";
import VirtualizedTableBody from "./VirtualizedTableBody";
import GridLoadError from "./GridLoadError";

const CommonGrid = (props) => {
  const gridState = useCommonGrid(props);
  const {
    header = true,
    footer = true,
    status = "fulfilled",
    minHeight = "700px",
    height = null,
    className = "",
    title,
    isDifferent = false,
    onRetry,
  } = props;
  return (
    <GridProvider value={gridState}>
      <div className={`rounded pb-2 ${className}`}>
        <div
          className="mx-2 mb-5 bg-white p-0 rounded w-100"
          style={{ height: height }}
        >
          <div
            className={classes.tableBackground}
            style={{ minHeight: minHeight }}
          >
            {header && <TableHeader />}
            {status === "fulfilled" ? (
              <>
                {!gridState.viewAllModal ? (
                  <VirtualizedTableBody isDifferent={isDifferent} />
                ) : (
                  <TableBody />
                )}
                {footer && <TableFooter />}
              </>
            ) : status === "failed" ? (
              <GridLoadError title={title} onRetry={onRetry} />
            ) : (
              <SpinnerBlock className={className} />
            )}
          </div>
        </div>
      </div>
    </GridProvider>
  );
};

export default CommonGrid;
